import { FC } from 'react';

export const ResetPasswordBackground: FC = () => {
  return <img className='h-dvh w-full rounded-es-[10dvh] rounded-ss-[10dvh] object-cover' src='/postel_rectangle.png' />;
};
